export default __webpack_public_path__ + "static/media/gl-14.5b8e5ca5.png";